if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            // console.log(MutationList)
            for (let item of MutationList) {
                if (item.target.classList.contains('predictive-search')) {
                    handleCartDrawerFooterMutation()
                }
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    }, 300)

    async function handleCartDrawerFooterMutation()  {
        if (BSS_B2B) {
            const res = await BSS_B2B.storage.productStorage.load();
            if (res) {
                if (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size) {
                    BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
                    ...res
                    });
                }
            }
        }
    }
}

